import { render } from "./backgroundPresenter.vue?vue&type=template&id=effa1d2a&scoped=true"
import script from "./backgroundPresenter.vue?vue&type=script&lang=js"
export * from "./backgroundPresenter.vue?vue&type=script&lang=js"

import "./backgroundPresenter.vue?vue&type=style&index=0&id=effa1d2a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-effa1d2a"]])

export default __exports__